import React, { Component } from "react"
import { DEFAULT } from "../../../config"
import { connect } from "react-redux"
import { Map as GoogleMap, GoogleApiWrapper } from "google-maps-react"
import Markers from "../../../media/Images"
import programador from "../../../media/images/programador.svg"

import { MarkerClusterer, SuperClusterViewportAlgorithm } from "@googlemaps/markerclusterer"

import {
    handleFetchMedia,
    handleFetchFilters,
    handleSetFavoriteMedium,
    handleShowMediaModal,
    handleSetCurrentMedium,
    handleSetMarkers,
    handleSetMarkerClusterer,
    handleSetMapCircle,
    handleSetMapCircleBatch,
    handleSetMap,
    // handleSetLoading,
} from "../../../actions/mediaAction"
import { countries } from "../../../utils/countries"
// import { country_settings } from "../../../utils/country_settings"
import { withTranslation } from 'react-i18next';

const _iconCache = {}
const _getIcon = (google, iconType) => {
    if (_iconCache[iconType]) return _iconCache[iconType]
    const icon = {
        url: Markers[iconType] ?? Markers.iconMaker,
        anchor: new google.maps.Point(16, 16),
        scaledSize: new google.maps.Size(38, 34),
    }
    _iconCache[iconType] = icon
    return icon
}

class MapContainer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            showModalDesc: false,
            currentMedium: null,
            initialCenter: {
                lat: 22.5650849,
                lng: -103.5364406,
            },
            zoom: 6,
            minZoom: 5,
            showMarkers: 0,
            markerClusterer: null,
            trafficLayer: new this.props.google.maps.TrafficLayer(),
            trafficShow: false,
            infoWindow: new this.props.google.maps.InfoWindow(),
            country: this.props.country,
            markers: [],
            renderMarkersAttemps: 0,
            mediaFiltered: []
        }
        this.renderMarkerCluster = this.renderMarkerCluster.bind(this)
        this.getMarker = this.getMarker.bind(this)
        this.showMediaModal = this.showMediaModal.bind(this)
        this.drawAdvertisingCircles = this.drawAdvertisingCircles.bind(this)
        this.drawMarkerGroup = this.drawMarkerGroup.bind(this)
        this.hideShowCircles = this.hideShowCircles.bind(this)
        this.getPosition = this.getPosition.bind(this)
        this.getCountryAndMoveToOnMap = this.getCountryAndMoveToOnMap.bind(this)
    }

    componentDidMount() {
        this.props.dispatch(handleFetchFilters())
        this.getCountryAndMoveToOnMap()
    }

    componentDidUpdate(prevProps, prevState) {
        const prev = prevProps.media.mediaFiltered
        const next = this.props.media.mediaFiltered
        if (prev === next) return
        if (prev.length === next.length && prev.length > 0) {
            const prevId = prev[0] && prev[0].id
            const nextId = next[0] && next[0].id
            const prevLast = prev[prev.length - 1] && prev[prev.length - 1].id
            const nextLast = next[next.length - 1] && next[next.length - 1].id
            if (prevId === nextId && prevLast === nextLast) return
        }
        this.setState({ mediaFiltered: next }, () => {
            if (this._renderRaf) cancelAnimationFrame(this._renderRaf)
            this._renderRaf = requestAnimationFrame(() => this.renderMarkerCluster())
        })
    }

    getCountryAndMoveToOnMap () {
        const self = this
        const map = this.refs.map.map
        if ("geolocation" in navigator && this.state.country === undefined) {
            navigator.geolocation.getCurrentPosition(function(position) {
                const result = new window.google.maps.Geocoder().geocode({
                    location: {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                    }
                })
                result.then(res => {
                    const results = res.results
                    if(results[0]) {
                        const location = results[0]
                        const country = location.address_components.find(component => component.types.includes("country"))
                        if (country) {
                            var request = {
                                location: map.getCenter(),
                                query: `country  ${country.long_name}`,
                                type: 'country'
                            }
                            
                            self.setState({markers: []})
                            self.props.setCountry(country.short_name)
                            self.props.dispatch(handleFetchMedia(country.short_name))
                            const service = new window.google.maps.places.PlacesService(map)
                            if(self.props.countryHasSettings(country.short_name)) {
                                service.textSearch(request, (places, status) => {
                                    const countryPlace = places.find(place => place.types.includes("country"))
                                    if(countryPlace) {
                                        map.panTo(countryPlace.geometry.location)
                                        self.renderMarkerCluster()
                                    } else {
                                        console.log("Country not found");
                                    }
                                })
                            } else {
                                console.log("country without settings")
                            }
                        } else {
                            console.log("Country not found");
                        }
                    }
                })
            })
        } else {
            // console.log("Not Available");
        }
        
        if (this.state.country !== undefined) {
            const country = this.state.country.toUpperCase()
            self.props.setCountry(country)
            self.props.dispatch(handleFetchMedia(country))
            const countryName = countries[country] ? countries[country] : 'México'
            var request = {
                location: map.getCenter(),
                query: `country  ${countryName}`,
                type: 'country'
            }
    
            const service = new window.google.maps.places.PlacesService(map)
            
            service.textSearch(request, (places, status) => {
                const country = places.find(place => place.types.includes("country"))
                if(country) {
                    map.panTo(country.geometry.location)
                } else {
                    console.log("Country not found");
                }
            })
        } else {
            const defaultCountry = 'MX'
            self.props.setCountry(defaultCountry)
            self.props.dispatch(handleFetchMedia(defaultCountry))
            const countryName = countries[defaultCountry] ? countries[defaultCountry] : 'México'
            var request = {
                location: map.getCenter(),
                query: `country  ${countryName}`,
                type: 'country'
            }
    
            const service = new window.google.maps.places.PlacesService(map)
            
            service.textSearch(request, (places, status) => {
                const country = places.find(place => place.types.includes("country"))
                if(country) {
                    map.panTo(country.geometry.location)
                } else {
                    console.log("Country not found");
                }
            })
        }
        
    }

    _getProgramadorMarker() {
        if (this._programadorMarker) return this._programadorMarker
        const m = new this.props.google.maps.Marker({
            icon: {
                url: programador,
                anchor: new this.props.google.maps.Point(16, 16),
                scaledSize: new this.props.google.maps.Size(24, 24),
            },
            position: this.getPosition(),
            title: "Develop by E.G."
        });
        m.addListener('click', () => {
            const infoWindow = new this.props.google.maps.InfoWindow({
                content: "Hola, soy el programador que realizó esta plataforma, pronto me verás por otro lado del mundo."
            });
            infoWindow.open(this.props.media.map, m);
        });
        this._programadorMarker = m
        return m
    }

    renderMarkerCluster() {
        const media = this.state.mediaFiltered;
        if (media.length === 0) return;

        if (!this._markersById) this._markersById = new Map()
        if (this._lastClustererInstance !== this.state.markerClusterer) {
            this._lastClustererInstance = this.state.markerClusterer
            this._clustererInitialized = false
            this._markersById = new Map()
            this._programadorMarker = null
        }

        const nextIds = new Set(media.map(m => m.full_code))
        const toRemove = []
        this._markersById.forEach((marker, code) => {
            if (!nextIds.has(code)) {
                toRemove.push(marker)
                this._markersById.delete(code)
            }
        })

        const toAdd = []
        for (const medium of media) {
            if (!this._markersById.has(medium.full_code)) {
                const marker = this.getMarker(medium)
                this._markersById.set(medium.full_code, marker)
                toAdd.push(marker)
            }
        }

        const programadorMarker = this._getProgramadorMarker()
        const allMarkers = [programadorMarker, ...this._markersById.values()]

        this.setState({ markers: allMarkers })
        this.props.dispatch(handleSetMarkers(allMarkers))

        if (this.state.markerClusterer) {
            const clusterer = this.state.markerClusterer
            if (!this._clustererInitialized) {
                clusterer.clearMarkers()
                clusterer.addMarkers(allMarkers)
                this._clustererInitialized = true
                this.drawAdvertisingCircles(allMarkers)
            } else {
                if (toRemove.length > 0) clusterer.removeMarkers(toRemove, true)
                if (toAdd.length > 0) clusterer.addMarkers(toAdd, true)
                if (toAdd.length > 0 || toRemove.length > 0) {
                    clusterer.render()
                    this.drawAdvertisingCircles(allMarkers)
                }
            }
        }
    }

    showMediaModal() {
        this.props.dispatch(handleShowMediaModal(true))
    }

    onMarkerClick(marker, medium) {
        this.props.dispatch(handleSetCurrentMedium(medium))
        this.showMediaModal()
    }

    getMarker(medium) {
        const type = medium.type.original.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase()
        let iconType = medium.type.original_glo ? medium.type.original_glo : medium.type.original
        iconType = iconType.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase()

        const icon = _getIcon(this.props.google, iconType)

        const latlng = new this.props.google.maps.LatLng(
            medium.lattitude,
            medium.longitude
        );

        const marker = new this.props.google.maps.Marker({
            icon: icon,
            position: latlng,
            title: type,
            code: medium.full_code
        });

        // store original position so drawAdvertisingCircles can restore it on each redraw
        marker._originalPosition = latlng;

        this.props.google.maps.event.addListener(marker, "click", () => {
            this.onMarkerClick(marker, medium);
        });

        return marker;
    }

    handleAddToFavorite(medium) {
        this.props.dispatch(handleSetFavoriteMedium(medium))
    }

    drawAdvertisingCircles(markers = null) {
        if (!markers) return

        // remove all previous circle overlays from the map before redrawing;
        // without this, old circles accumulate on every filter/data change and
        // cause severe lag on zoom in dense cities
        if (this.props.media.mapCircleList) {
            this.props.media.mapCircleList.forEach(c => c.setMap(null))
        }

        // restore each marker to its original position before detecting
        // duplicates — drawMarkerGroup offsets stacked markers, so without
        // this the offsets compound on every redraw
        markers.forEach(marker => {
            if (marker._originalPosition) marker.setPosition(marker._originalPosition)
        })

        const markerMap = {};
        const filteredMarkers = [];
        markers.sort((a, b) => (a.getPosition()?.lat() ?? 0) - (b.getPosition()?.lat() ?? 0))
        for (const marker of markers) {
            const pos = marker.getPosition()
            if (!pos) continue
            const key = `${pos.lat()}_${pos.lng()}`
            if (markerMap[key]) filteredMarkers.push(marker)
            markerMap[key] = true
        }
        filteredMarkers.sort((a, b) => a.position.lat() - b.position.lat())
        const newCircles = this.drawMarkerGroup(filteredMarkers)
        // dispatch unconditionally so the store never holds stale circle refs
        this.props.dispatch(handleSetMapCircleBatch(newCircles))
    }

    drawMarkerGroup(markers) {
        const circleOffsets = [
            { lat: 0.00015, lng: 0.00015 },
            { lat: -0.00015, lng: -0.00015 },
            { lat: 0.00015, lng: -0.00015 },
            { lat: -0.00015, lng: 0.00015 },
            { lat: -0.0002, lng: 0.0002 },
            { lat: -0.0002, lng: -0.0002 },
            { lat: 0.0002, lng: -0.0002 },
            { lat: 0.0002, lng: 0.0002 },
            { lat: -0.00009, lng: 0.00009 },
            { lat: 0.00009, lng: -0.00009 },
            { lat: -0.00009, lng: -0.0002 },
            { lat: -0.00009, lng: 0.0002 },
            { lat: 0.00009, lng: 0.0002 },
            { lat: 0.00009, lng: -0.0002 },
            { lat: -0.0002, lng: -0.00009 },
            { lat: 0.0002, lng: -0.00009 },
            { lat: -0.0002, lng: 0.00009 },
            { lat: 0.0002, lng: 0.00009 },
            { lat: -0.0001, lng: 0.0002 },
            { lat: -0.0001, lng: -0.0002 },
            { lat: 0.0001, lng: 0.0002 },
            { lat: 0.0001, lng: -0.0002 }
        ];

        const circles = []
        let equals = 0;
        let referenceMarker = markers[0];

        for (let index = 1; index < markers.length; index++) {
            const marker = markers[index];
            const refPos = referenceMarker.getPosition()
            const markerPos = marker.getPosition()
            if (!refPos || !markerPos) { referenceMarker = marker; equals = 0; continue }
            if (refPos.equals(markerPos)) {
                const offset = circleOffsets[equals % circleOffsets.length];
                if (equals === 0) {
                    const advertisingCircle = new this.props.google.maps.Circle({
                        strokeColor: "#F88D2B",
                        strokeOpacity: 0.5,
                        strokeWeight: 2,
                        fillColor: "#F88D2B",
                        fillOpacity: 0.35,
                        map: this.refs.map.map,
                        center: refPos,
                        radius: 25
                    });
                    advertisingCircle._centerKey = `${refPos.lat()}_${refPos.lng()}`
                    circles.push(advertisingCircle)
                }

                marker.setPosition(new this.props.google.maps.LatLng(
                    Number(refPos.lat()) + offset.lat,
                    Number(refPos.lng()) + offset.lng
                ));

                equals++;
            } else {
                referenceMarker = marker;
                equals = 0;
            }
        }
        return circles
    }
    
    

    hideShowCircles(show) {
        if (this.props.media.mapCircleList) {
            this.props.media.mapCircleList.forEach((circle) => {
                if (show === circle.getVisible()) return false
                circle.setVisible(show)
            })
        }
    }

    getPosition() {
        let date = (new Date()).getTime()
        switch(date) {
            case date < (new Date(2020, 12, 25)).getTime():
                return new this.props.google.maps.LatLng(
                    -73.9499962,
                    -121.0
                )
            case date >= (new Date(2020, 12, 25, 0)).getTime() && date <= (new Date(2021, 1, 1, 0)).getTime():
                return new this.props.google.maps.LatLng(
                    -73.9499962,
                    -42.872449
                )
            case date >= (new Date(2021, 1, 1, 0)).getTime():
                return new this.props.google.maps.LatLng(
                    66.178962, 
                    100.062345
                )
            default:
                return new this.props.google.maps.LatLng(
                    -73.9499962,
                    -121.0
                )
        }
    }

    render() {
        const {t} = this.props
        let handleOnZoomChanged = (e, map) => {
            // this.drawAdvertisingCircles()
            // const showByZoom = 18
            if (map.getZoom() >= 18) this.hideShowCircles(true)
            else this.hideShowCircles(false)
            // if (this.state.markerClusterer) {
            //     //Test to get the clusters
            //     let clusters = this.state.markerClusterer.getClusters()
            //     console.log(clusters)
            //     clusters = clusters.map(va => va)
            //     console.log(clusters)
            // }
            // if (map.getZoom() >= showByZoom) {
            // }
            // if (map) {
            //   console.log(map)
            //   console.log(map.getZoom())
            //   if (map.getZoom() < showByZoom) {
            //     this.setState({showMarkers: 0})
            //   } else if (map.getZoom() >= showByZoom) {
            //     this.setState({showMarkers: 1})
            //   }
            // }
        }

        let trafficControl = (controlDiv, map) => {
            // Set CSS for the control border.
            const controlUI = document.createElement("div")
            controlUI.style.backgroundColor = "#fff"
            controlUI.style.border = "2px solid #fff"
            controlUI.style.borderRadius = "3px"
            controlUI.style.boxShadow = "0 2px 6px rgba(0,0,0,.3)"
            controlUI.style.cursor = "pointer"
            controlUI.style.marginBottom = "22px"
            controlUI.style.textAlign = "center"
            controlUI.title = "Click to recenter the map"
            controlDiv.appendChild(controlUI)
          
            // Set CSS for the control interior.
            const controlText = document.createElement("div")
            controlText.style.color = "rgb(25,25,25)"
            controlText.style.fontFamily = "Roboto,Arial,sans-serif"
            controlText.style.fontSize = "16px"
            controlText.style.lineHeight = "38px"
            controlText.style.paddingLeft = "5px"
            controlText.style.paddingRight = "5px"
            controlText.innerHTML = t("map.show_traffic")
            controlUI.appendChild(controlText)

            if(controlUI){
                // Setup the click event listeners: simply set the map to Chicago.
                controlUI.addEventListener("click", () => {
                    var trafficLayer = this.state.trafficLayer
                    this.setState({trafficShow: !this.state.trafficShow})
                    if(this.state.trafficShow) {
                        controlText.innerHTML = t("map.hide_traffic")
                        trafficLayer.setMap(map)
                    } else {
                        controlText.innerHTML = t("map.show_traffic")
                        trafficLayer.setMap(null)
                    }
                });
            }
          
        }

        let measureControl = (controlDiv, map) => {
            let measureMarkers = []
            let mearureLines = []
            let clearMeasureMarkers = false
            let totalDistance = 0
            let marketID = 0
            // Set CSS for the control border.
            const controlUI = document.createElement("div")
            controlUI.style.backgroundColor = "#fff"
            controlUI.style.border = "2px solid #fff"
            controlUI.style.borderRadius = "3px"
            controlUI.style.boxShadow = "0 2px 6px rgba(0,0,0,.3)"
            controlUI.style.cursor = "pointer"
            controlUI.style.marginBottom = "22px"
            controlUI.style.textAlign = "center"
            controlUI.title = "Click to recenter the map"
            controlDiv.appendChild(controlUI)
          
            // Set CSS for the control interior.
            const controlText = document.createElement("div")
            controlText.style.color = "rgb(25,25,25)"
            controlText.style.fontFamily = "Roboto,Arial,sans-serif"
            controlText.style.fontSize = "16px"
            controlText.style.lineHeight = "38px"
            controlText.style.paddingLeft = "5px"
            controlText.style.paddingRight = "5px"
            controlText.innerHTML = t("map.measure_distance")
            controlUI.appendChild(controlText)
          
            if(controlUI){
                controlUI.addEventListener("click", () => {
                    this.props.google.maps.event.addListener(map, 'click', function(event) {
                        placeMarker(event.latLng);
                    });
                    controlText.innerHTML = `${totalDistance.toFixed(2)} KM`
                    if (clearMeasureMarkers) {
                        this.props.google.maps.event.clearInstanceListeners(map, 'click')
                        measureMarkers.forEach(marker => {
                            marker.setMap(null)
                        })
                        mearureLines.forEach(line => {
                            line.setMap(null)
                        })
                        mearureLines = []
                        measureMarkers = []
                        controlText.innerHTML = t("map.measure_distance")
                    }
                    clearMeasureMarkers = !clearMeasureMarkers
                    // var trafficLayer = this.state.trafficLayer
                    // this.setState({trafficShow: !this.state.trafficShow})
                    // if(this.state.trafficShow) {
                    //     controlText.innerHTML = "Ocultar tráfico"
                    //     trafficLayer.setMap(map)
                    // } else {
                    //     controlText.innerHTML = "Mostrar tráfico"
                    //     trafficLayer.setMap(null)
                    // }
                });
            }
            // Setup the click event listeners: simply set the map to Chicago.

            const placeMarker = (location) => {
                const measureMarker = new this.props.google.maps.Marker({
                    position: location, 
                    map: map,
                    draggable:true,
                    id: marketID++
                })
                measureMarker.addListener('drag', () => {
                    reloadLines()
                })
                measureMarker.addListener('click', (event) => {
                    let indexMarker = 0
                    measureMarkers.forEach((measureMarker, index) => {
                        if(measureMarker.position.lat() === event.latLng.lat() && measureMarker.position.lng() === event.latLng.lng())
                            indexMarker = index
                    })
                    measureMarkers[indexMarker].setMap(null)
                    measureMarkers.splice(indexMarker, 1)
                    reloadLines()
                })
                measureMarkers.push(
                    measureMarker
                )
                reloadLines()
            }

            const reloadLines = () => {
                if (mearureLines.length) {
                    mearureLines.forEach(line => {
                        line.setMap(null)
                    })
                }
                mearureLines = []
                totalDistance = 0
                if (measureMarkers.length > 1) {
                    let coords = []
                    measureMarkers.forEach(marker => {
                        coords.push(marker.position)
                    })
                    measureMarkers.sort((markerOne, markerTwo) => {
                        totalDistance += parseFloat(calculateDistance(markerOne.position, markerTwo.position))
                    })
                    var line = new this.props.google.maps.Polyline({
                        path: coords,
                        geodesic: true,
                        strokeColor: '#FF0000',
                        strokeOpacity: 1.0,
                        strokeWeight: 2
                    })
                    mearureLines.push(line)
                    line.setMap(map)
                }
                controlText.innerHTML = `${totalDistance.toFixed(2)} KM`
            }

            var rad = function(x) {
                return x * Math.PI / 180;
            }

            const calculateDistance = (p1, p2) => {
                return (this.props.google.maps.geometry.spherical.computeDistanceBetween(p1, p2) / 1000).toFixed(2);
            }
        }

        let handleOnReady = (mapProps, map) => {
            if (this.refs.map) {
                this.props.dispatch(handleSetMap(this.refs.map.map))

                const clusterRenderer = {
                    render: ({ count, position }) => {
                        return new this.props.google.maps.Marker({
                            position,
                            icon: {
                                url: Markers.markerClusterer,
                                scaledSize: new this.props.google.maps.Size(54, 54),
                            },
                            label: {
                                text: String(count),
                                color: 'white',
                                fontSize: '13px',
                                fontWeight: 'bold',
                            },
                            zIndex: Number(this.props.google.maps.Marker.MAX_ZINDEX) + count,
                        })
                    }
                }

                const baseAlgorithm = new SuperClusterViewportAlgorithm({ maxZoom: 17, radius: 60 })
                const originalCalculate = baseAlgorithm.calculate.bind(baseAlgorithm)
                baseAlgorithm.calculate = (input) => originalCalculate({
                    ...input,
                    markers: input.markers.filter(m => m.getVisible ? m.getVisible() : true)
                })

                const markerClusterer = new MarkerClusterer({
                    map: this.refs.map.map,
                    markers: [],
                    algorithm: baseAlgorithm,
                    renderer: clusterRenderer,
                })

                this.setState({ markerClusterer })
                this.props.dispatch(handleSetMarkerClusterer(markerClusterer))
                this.renderMarkerCluster()

                const trafficControlDiv = document.createElement("div")
                trafficControl(trafficControlDiv, map)
                map.controls[this.props.google.maps.ControlPosition.BOTTOM_LEFT].push(trafficControlDiv)

                const measureControlDiv = document.createElement("div")
                measureControl(measureControlDiv, map)
                map.controls[this.props.google.maps.ControlPosition.RIGHT_CENTER].push(measureControlDiv)
            }
        }


        return (
            <GoogleMap
                ref="map"
                google={window.google}
                initialCenter={this.state.initialCenter}
                zoom={this.state.zoom}
                minZoom={this.state.minZoom}
                streetViewControl={true}
                onZoomChanged={handleOnZoomChanged}
                onReady={handleOnReady}
                fullscreenControl={false}
                style={{
                    width: "100%",
                    height: window.innerWidth < 500 ? '83vh' : '92vh'
                }}
            ></GoogleMap>
        )
    }
}

const mapStateToProps = (state) => ({ media: state.media })

export default connect(mapStateToProps)(
    GoogleApiWrapper({
        apiKey: DEFAULT.MAPS_API_KEY,
        libraries: ["places"],
    })(withTranslation()(MapContainer))
)
